import React, {memo, useState, useEffect} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {LocationPoint} from '@/common/interfaces/location';
import {WeatherShareMenu} from '../WeatherShareMenu';
import styles from './WeatherShareButton.css';

interface WeatherShareButtonProps {
	location: LocationPoint;
	date: string;
}

export const WeatherShareButton = memo<WeatherShareButtonProps>(props => {
	const {location, date} = props;

	const [isOpened, setIsOpened] = useState(false);
	const t = useLocalizer();

	const toggleOpen = () => {
		setIsOpened(!isOpened);
	};

	useEffect(() => {
		if (isOpened) {
			setIsOpened(false);
		}
	}, [date]);

	return (
		<div className={styles.root}>
			<button className={styles.button} type='button' onClick={toggleOpen}>
				{t('shareTitle')}
			</button>
			{isOpened && <WeatherShareMenu location={location} date={date} onClose={toggleOpen} />}
		</div>
	);
});

WeatherShareButton.displayName = 'WeatherShareButton';
